import React from 'react';
import CTAButton from '../../shared/CTAButton';
import { useFadeUp } from '../../shared/useFadeUp';
import { webReportMobile, webReportChallenge } from '../../../assets/v2';
import './webReport.css';

const TAGS = ['PDF export', 'TREC-compliant', 'Branded with your logo'];

const WebReport: React.FC = () => {
  const title = useFadeUp<HTMLHeadingElement>();
  const copy = useFadeUp<HTMLParagraphElement>();
  const cta = useFadeUp<HTMLDivElement>();
  const tags = useFadeUp<HTMLDivElement>();
  const visual = useFadeUp<HTMLDivElement>();

  return (
    <section className="v2-webreport" id="web-report" data-page-bg="#ebf2ff">
      <div className="v2-webreport__container">
        <div className="v2-webreport__text">
          <h2
            ref={title.ref}
            className={`ui-h2 v2-webreport__title fade-up ${title.isVisible ? 'is-visible' : ''}`}
          >
            Your Judgment. Fully Preserved.
          </h2>
          <p
            ref={copy.ref}
            className={`ui-body v2-webreport__copy fade-up ${copy.isVisible ? 'is-visible' : ''}`}
          >
            Morph drafts and organizes — you review and decide. Nothing is sent
            without your approval. Your standards, your responsibility, your
            name on the inspection report.
          </p>
          <div
            ref={cta.ref}
            className={`fade-up ${cta.isVisible ? 'is-visible' : ''}`}
          >
            <CTAButton
              as="a"
              variant="outline-light"
              size="lg"
              href="https://app.morph-technologies.com/compiled-reports/141d7cd1-11ae-4f79-8986-b1c3c009e376"
              target="_blank"
              rel="noopener noreferrer"
            >
              See a sample report
            </CTAButton>
          </div>
          <div
            ref={tags.ref}
            className={`v2-webreport__tags fade-up ${tags.isVisible ? 'is-visible' : ''}`}
          >
            {TAGS.map((t) => (
              <span key={t} className="v2-webreport__tag">
                {t}
              </span>
            ))}
          </div>
        </div>

        <div
          ref={visual.ref}
          className={`v2-webreport__visual fade-up ${visual.isVisible ? 'is-visible' : ''}`}
        >
          <div className="v2-webreport__mobile">
            <img src={webReportMobile} alt="Morph web report on mobile" />
          </div>
          <div className="v2-webreport__laptop">
            <img
              src={webReportChallenge}
              alt="Morph web report challenge summary"
            />
            <div className="v2-webreport__chin" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebReport;
